import { jsx as _jsx } from "react/jsx-runtime";
import { CalendarTodayOutlined, Email, FacebookRounded, FlagOutlined, ForumOutlined, HomeOutlined, Instagram, LaptopOutlined, LocationOn, Phone, Twitter, YouTube, } from "@mui/icons-material";
import { Footer } from "./footer";
export const FooterContainer = () => {
    const social = [
        { Icon: Instagram, link: "https://instagram.com/governoes" },
        { Icon: FacebookRounded, link: "https://facebook.com/governoes" },
        { Icon: YouTube, link: "https://youtube.com/governoes" },
        { Icon: Twitter, link: "https://twitter.com/governoes" },
    ];
    const lists = [
        {
            title: "Mapa do nosso Portal",
            Icon: LaptopOutlined,
            linkList: [
                { text: "Início", Icon: HomeOutlined, link: "/" },
                {
                    text: "Serviços Disponíveis",
                    Icon: FlagOutlined,
                    link: "/app/catalog/carta-de-servicos",
                },
                {
                    text: "Órgãos e Secretarias",
                    Icon: ForumOutlined,
                    link: "app/catalog/orgaos-e-secretarias",
                },
                {
                    text: "Notícias",
                    Icon: CalendarTodayOutlined,
                    link: "/app/catalog/noticias",
                },
            ],
        },
    ];
    const contacts = [
        {
            Icon: Phone,
            text: "+55 (27) 3636-1024",
        },
        {
            Icon: LocationOn,
            text: "Praça João Clímaco, 142 - Cidade Alta, Centro, Vitória/ES - CEP: 29015-110",
        },
        {
            Icon: Email,
            text: "ouvidoria@es.gov.br",
        },
    ];
    return _jsx(Footer, { lists: lists, social: social, contacts: contacts });
};
